var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "screen" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
          staticClass: "screen-loading",
        },
        [
          _c("p", { staticClass: "screen-loading-title" }, [
            _vm._v("Loading..."),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "screen-threeMap" },
        [
          _c("HongKongMap", {
            on: { percentage: _vm.percentageFunc, mapReady: _vm.mapReadyFunc },
          }),
        ],
        1
      ),
      _c(
        "header",
        {
          ref: "header",
          staticClass: "screen-header",
          style: _vm.headerDomCSS,
        },
        [
          _c("div", { staticClass: "screen-header-date" }, [
            _c("p", { staticClass: "screen-header-date-font" }, [
              _c("i", { staticClass: "iconfont icon-rili" }),
              _c("span", { staticClass: "time" }, [_vm._v(_vm._s(_vm.time))]),
              _c("span", { staticClass: "week" }, [
                _vm._v(_vm._s(_vm.$t(_vm.week))),
              ]),
              _c("span", { staticClass: "date" }, [_vm._v(_vm._s(_vm.date))]),
            ]),
          ]),
          _c("h1", { staticClass: "screen-header-title" }, [
            _vm._v(_vm._s(_vm.$t("screen.title"))),
          ]),
          _c("div", { staticClass: "screen-header-menu" }, [
            _c(
              "div",
              { staticClass: "backend", on: { click: _vm.goBackend } },
              [_c("i", { staticClass: "iconfont icon-kuozhanping" })]
            ),
            _vm._m(0),
            _c("div", { staticClass: "logout", on: { click: _vm.logout } }, [
              _c("i", { staticClass: "iconfont icon-tuichu" }),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        { ref: "left", staticClass: "screen-left", style: _vm.leftDomCSS },
        [
          _c("ScreenCard", {
            staticClass: "screen-left-top",
            attrs: { title: "screen.driverAvailabilityRate" },
            scopedSlots: _vm._u([
              {
                key: "container",
                fn: function () {
                  return [
                    _c("AnnulusPanel", {
                      attrs: { seriesData: _vm.onlineData },
                      on: { ready: _vm.initOnlineData },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("ScreenCard", {
            staticClass: "screen-left-center",
            attrs: { title: "screen.paymentProportion" },
            scopedSlots: _vm._u([
              {
                key: "container",
                fn: function () {
                  return [
                    _c("DisperseAnnPanel", {
                      attrs: { seriesData: _vm.payData },
                      on: { ready: _vm.initPaymentData },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("ScreenCard", {
            staticClass: "screen-left-bottom",
            attrs: { title: "screen.transportPassengerFlow" },
            scopedSlots: _vm._u([
              {
                key: "container",
                fn: function () {
                  return [
                    _c("HistogramPanel", {
                      attrs: {
                        yAxisData: _vm.transportData.yAxisData,
                        seriesData: _vm.transportData.seriesData,
                      },
                      on: { ready: _vm.initTransportData },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { ref: "top", staticClass: "screen-middleTop", style: _vm.topDomCSS },
        [
          _c("div", { staticClass: "screen-middleTop-dataDiv orderNum" }, [
            _c("p", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("screen.todayOrderQuantity"))),
            ]),
            _c("p", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.orderStatistics.orderCount)),
            ]),
          ]),
          _c("div", { staticClass: "screen-middleTop-dataDiv ongoing" }, [
            _c("p", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("screen.ongoingOrders"))),
            ]),
            _c("p", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.orderStatistics.underWay)),
            ]),
          ]),
          _c("div", { staticClass: "screen-middleTop-dataDiv totalRevenue" }, [
            _c("p", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("screen.todayTotalRevenue"))),
            ]),
            _c("p", { staticClass: "value" }, [
              _vm._v(_vm._s(_vm.orderStatistics.actualPayAmount)),
            ]),
          ]),
        ]
      ),
      _c("ScreenCard", {
        ref: "bottom",
        staticClass: "screen-middleBottom",
        style: _vm.bottomDomCSS,
        attrs: { title: "screen.orderCurveChart" },
        scopedSlots: _vm._u([
          {
            key: "container",
            fn: function () {
              return [
                _c("AreaPanel", {
                  attrs: {
                    xAxisData: _vm.orderData.xAxisData,
                    seriesData: _vm.orderData.seriesData,
                    legendData: _vm.orderData.legendData,
                  },
                  on: { ready: _vm.initOrderData },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { ref: "right", staticClass: "screen-right", style: _vm.rightDomCSS },
        [
          _c("ScreenCard", {
            staticClass: "screen-right-top",
            attrs: {
              title: "screen.driverIncomeEvaluationScore",
              isColumn: true,
              justifyContent: "space-between",
              alignItems: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "container",
                fn: function () {
                  return _vm._l(_vm.driverTopFive, function (item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "screen-right-top-ranking" },
                      [
                        index === 0
                          ? _c("div", {
                              staticClass: "screen-right-top-ranking-no no1",
                            })
                          : index === 1
                          ? _c("div", {
                              staticClass: "screen-right-top-ranking-no no2",
                            })
                          : index === 2
                          ? _c("div", {
                              staticClass: "screen-right-top-ranking-no no3",
                            })
                          : _c(
                              "div",
                              { staticClass: "screen-right-top-ranking-no" },
                              [_vm._v(" " + _vm._s(index + 1) + " ")]
                            ),
                        _c(
                          "div",
                          { staticClass: "screen-right-top-ranking-dataInfo" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "screen-right-top-ranking-dataInfo-information",
                              },
                              [
                                _c("p", { staticClass: "name" }, [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                                _c("p", { staticClass: "income" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("screen.dailyIncome")) +
                                      " "
                                  ),
                                  _c("span", { staticClass: "number" }, [
                                    _vm._v(_vm._s(item.income)),
                                  ]),
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("common.unit")) + " "
                                  ),
                                ]),
                                _c("p", { staticClass: "score" }, [
                                  _vm._v(" " + _vm._s(_vm.$t("screen.score"))),
                                  _c("span", { staticClass: "number" }, [
                                    _vm._v(_vm._s(item.score)),
                                  ]),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "screen-right-top-ranking-dataInfo-value",
                              },
                              [
                                _c("div", {
                                  staticClass: "score",
                                  style: "width: " + item.score + "%;",
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  })
                },
                proxy: true,
              },
            ]),
          }),
          _c("ScreenCard", {
            staticClass: "screen-right-center",
            attrs: {
              title: "screen.dailyRevenueData",
              isColumn: true,
              justifyContent: "center",
              alignItems: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "container",
                fn: function () {
                  return [
                    _c("TransportPanel", {
                      attrs: { seriesData: _vm.passengerFlowData },
                      on: { ready: _vm.initPassengerFlowData },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c("ScreenCard", {
            staticClass: "screen-right-bottom",
            attrs: {
              title: "screen.recentTaxiDataInformation",
              isColumn: true,
              justifyContent: "center",
              alignItems: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "container",
                fn: function () {
                  return _vm._l(_vm.orderTopData, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.orderNo,
                        staticClass: "screen-right-bottom-orderInfo",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "screen-right-bottom-orderInfo-statusInfo",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "screen-right-bottom-orderInfo-statusInfo-top",
                              },
                              [
                                _c("p", { staticClass: "carType" }, [
                                  _vm._v(_vm._s(item.carType)),
                                ]),
                                _c("p", { staticClass: "orderTime" }, [
                                  _vm._v(_vm._s(item.time)),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "screen-right-bottom-orderInfo-statusInfo-bottom",
                              },
                              [
                                _c("p", { staticClass: "orderType" }, [
                                  _vm._v(_vm._s(item.orderType)),
                                ]),
                                _c("p", { staticClass: "orderStatus" }, [
                                  _vm._v(_vm._s(item.orderStatus)),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "line" }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "screen-right-bottom-orderInfo-addressInfo",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "screen-right-bottom-orderInfo-addressInfo-start",
                              },
                              [
                                _c("div", { staticClass: "icon" }, [
                                  _vm._v(_vm._s(_vm.$t("screen.common.start"))),
                                ]),
                                _c("p", { staticClass: "address" }, [
                                  _vm._v(_vm._s(item.startAddr)),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "screen-right-bottom-orderInfo-addressInfo-end",
                              },
                              [
                                _c("div", { staticClass: "icon" }, [
                                  _vm._v(_vm._s(_vm.$t("screen.common.end"))),
                                ]),
                                _c("p", { staticClass: "address" }, [
                                  _vm._v(_vm._s(item.endAddr)),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  })
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "setting" }, [
      _c("i", { staticClass: "iconfont icon-set" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }